import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorConnector } from '../control-value-accessor-connector';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextComponent),
      multi: true
    }
  ]
})
export class TextComponent extends ControlValueAccessorConnector implements ControlValueAccessor {
  @Input() placeholder: string = '';
  @Input() autocomplete: boolean = false;
  @Input() maxlength: number | null = null;
  @Input() hideWarning: boolean = false;
  @Input() showRequiredForApproval: boolean = false;
  @Input() value: string | null | undefined;
  @Input() readonly: boolean = false;
  @Input() disabledWithWhiteBg: boolean = false;
  @Input() title: boolean = false;
  @Input() attributeId = this.formControlName;
  @Input() labelMaori: string | null = null;
  @Input() isEditMode: boolean = true;
  @Input() isViewMode: boolean = false;
  /**
   * Renders the value as wrapped, read-only text instead of a single line input, so long
   * values are shown in full rather than being clipped. For computed fields the user cannot edit.
   */
  @Input() displayAsText: boolean = false;

  constructor() {
    super();
  }

  get ariaLabelText(): string {
    return [this.label, this.labelMaori].filter(Boolean).join(' ');
  }

  /**
   * Get the autocomplete input element value
   * @returns on/off state of the autocomplete
   */
  autoComplete() {
    return this.autocomplete ? 'on' : 'off';
  }
}
